'use client'

import React from 'react';
import styles from './FeatureGrid.module.css';
import { Button } from '@indxsearch/systm';

// icons
import {
  Search, Search_as_you_type, Rag_search, Cpu, Sliders_horizontal, Speedometer, Search_query, Shield, Filter, Personalise,
  ECommerce, Coverage, Analytics, Zap, Boost, Nuget
} from "@indxsearch/pixl";

interface IconProps {
  color?: string;
}

interface FeatureCell {
  icon: React.ReactNode;
  title: string;
  body: string;
  size?: 'normal' | 'large';
}

export default function FeatureGrid() {
  const features: FeatureCell[] = [
    {
      icon: <Search />,
      title: "Drop an ultra-fast, pattern-based search engine directly into your .NET codebase",
      body: "Download example projects",
      size: 'large'
    },
    {
      icon: <Search_as_you_type />,
      title: "Pattern-based matching",
      body: "Returns relevant search results automatically, even with messy or distorted input."
    },
    {
      icon: <Rag_search />,
      title: "Great for AI agents",
      body: "Fast structured retrieval for agent workflows and hybrid RAG pipelines."
    },
    {
      icon: <Cpu />,
      title: "Native C# engine",
      body: "A fully embeddable search engine with no dependencies."
    },
    {
      icon: <Sliders_horizontal />,
      title: "Zero tuning",
      body: "No tokenizers, analyzers, or configs. Simple levers when you want control."
    },
    {
      icon: <Speedometer />,
      title: "Blazing fast",
      body: "As much as 200× faster than traditional search engines."
    },
    {
      icon: <ECommerce />,
      title: "Boosts e-commerce sales",
      body: "Smarter relevance leads to better product discovery and more conversions."
    },
    {
      icon: <Search_query />,
      title: "Split-word understanding",
      body: "Handles combined and separated word forms automatically."
    },
    {
      icon: <Shield />,
      title: "Battle tested",
      body: "Trusted in high-load, high-volume production environments."
    }
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.grid}>
          {features.map((feature, index) => (
            <div
              key={index}
              className={`${styles.cell} ${feature.size === 'large' ? styles.large : ''}`}
            >
              <div className={feature.size === 'large' ? styles.largeTitle : styles.title}>
                {feature.title}
              </div>
              {feature.size === 'large' ? (
                <>
                  <div className={styles.coreimage}>
                    <div className={`${styles.core} ${styles.corebase}`}></div>
                    <div className={`${styles.core} ${styles.coreone}`}></div>
                    <div className={`${styles.core} ${styles.coretwo}`}>
                      <div className={styles.twoanimation}></div>
                    </div>
                    <div className={`${styles.core} ${styles.corethree}`}></div>
                    <div className={`${styles.core} ${styles.corenoise}`}></div>
                    <div className={`${styles.core} ${styles.coremeta}`}></div>
                    <div className={`${styles.core} ${styles.corestroke}`}></div>
                  </div>
                  <div className={styles.buttons}>
                    <Button variant="secondary" iconLeft={<Nuget/>} href="https://www.nuget.org/packages/IndxSearchLib/">
                      Get the Nuget
                    </Button>
                    <Button variant="ghost" href="https://github.com/indxSearch">
                      Download example projects
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.icon}>
                    {React.cloneElement(feature.icon as React.ReactElement<IconProps>, {
                      color: 'currentColor'
                    })}
                  </div>
                  <div className={styles.body}>{feature.body}</div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
